import { Component, Input } from '@angular/core';
import { AppService } from '@nk/access-block';

@Component({
  selector: 'nk-verify-email-error',
  templateUrl: './verify-email-error.component.html',
  styleUrls: ['./verify-email-error.component.scss'],
  standalone: false,
})
export class VerifyEmailErrorComponent {
  public verifyEmailJobSuccess: boolean;
  public verifyEmailJobError: boolean;
  public verifyEmailLoading: boolean;
  @Input() public localStorageEmail: string;
  constructor(private _appService: AppService) {}

  public resendVerificationEmail(email: string): void {
    this.verifyEmailLoading = true;
    this._appService.resendEmailVerification(email).subscribe(
      (payload) => {
        this.verifyEmailJobSuccess = true;
        this.verifyEmailLoading = false;
      },
      (error) => {
        this.verifyEmailJobError = true;
      },
    );
  }
}
